import { createSlice } from "@reduxjs/toolkit";
import { dashboardApi } from "../services/dashboardApi";

const initialState = {
  data: null,
};

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // builder
    //   .addMatcher(
    //     dashboardApi.endpoints.getAllDispatchers.matchFulfilled,
    //     (state, { payload }) => {
    //       state.data = payload.data;
    //     }
    //   )
    //   .addMatcher(dashboardApi.endpoints.getAllDispatchers.matchRejected, (state) => {
    //     state.data = null;
    //   });
  },
});

export const { setDashboardInfo, unsetDashboardInfo } = userSlice.actions;

export default userSlice.reducer;
